import _defineProperty from"/var/lib/jenkins/workspace/fcom.openapi/FCOM_UAT/fcom.fs2pro/source/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";function ownKeys(object,enumerableOnly){var keys=Object.keys(object);if(Object.getOwnPropertySymbols){var symbols=Object.getOwnPropertySymbols(object);if(enumerableOnly)symbols=symbols.filter(function(sym){return Object.getOwnPropertyDescriptor(object,sym).enumerable;});keys.push.apply(keys,symbols);}return keys;}function _objectSpread(target){for(var i=1;i<arguments.length;i++){var source=arguments[i]!=null?arguments[i]:{};if(i%2){ownKeys(source,true).forEach(function(key){_defineProperty(target,key,source[key]);});}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(target,Object.getOwnPropertyDescriptors(source));}else{ownKeys(source).forEach(function(key){Object.defineProperty(target,key,Object.getOwnPropertyDescriptor(source,key));});}}return target;}import*as queryString from'query-string';import axios from'../axios';import config from'../combineConfig';import{CommonUtils}from'utils';var globalVar=window._env_;var MARKET_URL=globalVar.api.API_MARKET_URL;var API_NEWS_SERVICE=globalVar.api.API_NEWS_SERVICE;var symbolService={// Lấy dữ liệu cho đặt lệnh 
getSymbolInfoMapping:function getSymbolInfoMapping(){return axios.get('/trade/mapping');},getQuote:function getQuote(symbol){return axios.get("/trade/quotes?symbols=".concat(symbol));//return axios.get(`https://tradeapi2.bsc.com.vn/trade/quotes?symbols=${symbol}`);
},// Lấy dữ liệu cho bảng giá
getSymbolInfo:function getSymbolInfo(){// return axios.get(`${MARKET_URL}/datafeed/instruments`);
return axios.get("".concat(MARKET_URL,"/datafeed/instruments?brief=true"));},// Lấy dữ liệu cho bảng giá
getSymbolInfoAll:function getSymbolInfoAll(){return axios.get("".concat(MARKET_URL,"/datafeed/quote"));},/**
     * sectorCode // Mã ngành 
     * code // Mã HĐ
     * @param {*} param0 
     * @returns 
     */getFcomSymbolInfoAll:function getFcomSymbolInfoAll(_ref){var sectorCode=_ref.sectorCode,code=_ref.code,floor=_ref.floor;var queryParams={sectorCode:sectorCode||undefined,code:code||undefined,floor:floor||undefined};return axios.get("".concat(MARKET_URL,"/datafeed/quote?")+queryString.stringify(queryParams));},getInstrument:function getInstrument(symbol,callType){if(callType=="miss"){return axios.get("".concat(MARKET_URL,"/datafeed/quote?code=").concat(symbol,"&&calltype=").concat(callType));}return axios.get("".concat(MARKET_URL,"/datafeed/quote?code=").concat(symbol));},getFixedSymbolList:function getFixedSymbolList(name){return axios.get("".concat(MARKET_URL,"/datafeed/quote/").concat(name));},/**
     * Lấy danh sách mã khuyến nghị cho bảng giá
     * @param {*} name 
     * @returns 
     */getRecommendSymbolList:function getRecommendSymbolList(){return axios.get("/userdata/recommendation/listSymbols");},getInstrumentByExchange:function getInstrumentByExchange(exchange){return axios.get("".concat(MARKET_URL,"/datafeed/quote?sectorCode=").concat(exchange));},getSymbolListByExchange:function getSymbolListByExchange(name){return axios.get("".concat(MARKET_URL,"/datafeed/quote?sectorCode=").concat(name));},getOddlotByExchange:function getOddlotByExchange(name,callType){if(callType=="miss"){return axios.get("".concat(MARKET_URL,"/datafeed/oddLotInstruments?exchange=").concat(name,"&&calltype=").concat(callType));}return axios.get("".concat(MARKET_URL,"/datafeed/oddLotInstruments?exchange=").concat(name));},/**
     * Load snapshot của thông tin index
     */getMarketInfoSnap:function getMarketInfoSnap(codes){// if (!codes) {
//     codes = config.ALL_INDEXES.map(element => {
//         return element.code
//     })
// }
return axios.get("".concat(MARKET_URL,"/datafeed/indexsnaps/")+(codes?codes.toString():""));},/**
     * Load snapshot của thông tin index
     * @param {*} codes 
     * @returns 
     */getFcomMarketInfoSnap:function getFcomMarketInfoSnap(codes){// if (!codes) {
//     codes = config.ALL_INDEXES.map(element => {
//         return element.code
//     })
// }
return axios.get("".concat(MARKET_URL,"/datafeed/index?code=")+(codes?codes.toString():""));},/**
     * Load lịch sử khớp lệnh theo index
     * @param {*} marketCode 
     * @param {*} index 
     * @returns 
     */getMarketHistoryByMarketCode:function getMarketHistoryByMarketCode(marketCode,index){return axios.get("".concat(MARKET_URL,"/datafeed/indexs/").concat(marketCode)+(index&&index>0?"?index=".concat(index):''));},/**
    * Load snapshot của thông tin translog
    */getTranslogSnap:function getTranslogSnap(symbol,index){// return axios.get(`datafeed/translogsnaps/` + symbol.toString() + (index && index > 0 ? `?index=${index}` : ''));
return axios.get("".concat(MARKET_URL,"/datafeed/translogsnaps/")+symbol.toString()+(index&&index>0?"?index=".concat(index):''));// hardcode bảo việt
},/**
   * Load All snapshot của thông tin translog
   */getAllTranslogSnap:function getAllTranslogSnap(symbol,index){// return axios.get(`datafeed/alltranslogs/` + symbol.toString() + (index && index > 0 ? `?index=${index}` : ''));
return axios.get("".concat(MARKET_URL,"/datafeed/alltranslogs/")+symbol.toString()+(index&&index>0?"?index=".concat(index):''));// hardcode bảo việt
},/**
     * 
     * @param {*} symbol 
     * @param {*} index // Lấy theo nextIndex - hiện tại chưa có luồng phân trang
     * @returns 
     */getFcomAllTranslogSnap:function getFcomAllTranslogSnap(symbol,index){// return axios.get(`datafeed/alltranslogs/` + symbol.toString() + (index && index > 0 ? `?index=${index}` : ''));
return axios.get("".concat(MARKET_URL,"/datafeed/translog?code=")+symbol.toString()+(index&&index>0?"?index=".concat(index):''));},/**
     * Load snapshot của thông tin orderbook
     * @param {} symbol 
     */getOrderBookSnap:function getOrderBookSnap(symbol){return axios.get("".concat(MARKET_URL,"/datafeed/orderbook/").concat(symbol));},/**
     * Lấy thông tin các mã sự kiện quyền , top tăng giảm giá trên bảng giá
     * @param {*} filterId
     * @returns 
     */getFilteredSymbolList:function getFilteredSymbolList(filterId){return axios.get("".concat(MARKET_URL,"/datafeed/instruments/filter?id=").concat(filterId));},/**
     * lấy thông tin các mã theo filterid, type và exchange
     * @param {*} filterId 
     * @param {*} exchange 
     * @param {*} type 
     * @returns 
     */getFilteredSymbolListByExchange:function getFilteredSymbolListByExchange(filterId,exchange,type){return axios.get("".concat(MARKET_URL,"/datafeed/instruments/filter?id=").concat(filterId,"&exchange=").concat(exchange,"&type=").concat(type));},/**
     * Lấy thông tin thỏa thuận theo sàn
     * @param {*} floorCode // mã sàn , VD: 'HOSE', 'HNX', 'UPCOM'
     * @returns 
     */getPutthroughSnapShot:function getPutthroughSnapShot(floorCode){return axios.get("".concat(MARKET_URL,"/datafeed/putthrough/").concat(floorCode));},/**
    * Lấy thông tin thỏa thuận theo sàn
    * @param {*} floorCode // mã sàn , VD: 'HOSE', 'HNX', 'UPCOM'
    * @returns 
    */getPTMatchSnapShot:function getPTMatchSnapShot(floorCode){return axios.get("".concat(MARKET_URL,"/datafeed/ptmatch/").concat(floorCode));},/**
    * Lấy dữ liệu cho biểu đồ khớp theo ngày (Không lấy theo tranlogs)
    * @param {*} symbol  
    * @returns 
    */getAllTranslogBySymbol:function getAllTranslogBySymbol(symbol){return axios.get("".concat(MARKET_URL,"/datafeed/alltranslogs/").concat(symbol));},/**
   * Lấy dữ liệu chart khớp theo list chỉ số index hoặc symbol
   * @param {*} symbols: Bao gồm cả chỉ số index và symbol VD: HOSE,30,HNX,SSI,ACB  
   * @returns 
   */getMarketHistory:function getMarketHistory(symbols,tradingDate){return axios.get("".concat(MARKET_URL,"/charts/historybydate?symbol=").concat(symbols,"&date=").concat(tradingDate));},// Tạm lấy link prod để test, cần xóa đi với bản bàn giao
/**
     * Lấy thông tin chi tiết mã CP
     * @param {*} symbol 
     * @returns 
     */getStockSymbolDetail:function getStockSymbolDetail(symbol,uacode){var queryParams={symbol:symbol||'',uacode:uacode||''};// return axios.get(`${API_NEWS_SERVICE}/news/getBaseIndicators?` + queryString.stringify(queryParams));
return axios.get("".concat(API_NEWS_SERVICE,"/report/instruments?")+queryString.stringify(queryParams));},/**
     * Lấy thông tin tin tức chi tiết mã 
     * @param {*} symbol 
     * @param {*} limitRow 
     * @param {*} index 
     * @returns 
     */getStockSymbolNews:function getStockSymbolNews(symbol,limitRow,index,language){var queryParams={symbols:symbol,limitRow:limitRow,index:index,language:language,size:limitRow,page:index};// return axios.get(`${API_NEWS_SERVICE}/news/getListNews?` + queryString.stringify(queryParams));
return axios.get("".concat(MARKET_URL,"/datafeed/news?")+queryString.stringify(queryParams));},/**
     * Lấy thông tin tin tức chi tiết mã 
     * @param {*} index 
     * @returns 
     */getDetailNew:function getDetailNew(index){return axios.get("".concat(API_NEWS_SERVICE,"/news/getNewsDetail/").concat(index));},/**
     * Lấy danh sách tìm kiếm
     * @param {*} symbol 
     * @param {*} limitRow 
     * @param {*} index 
     * @returns 
     */getNewsSearch:function getNewsSearch(index,language,limitRow,title){var queryParams={index:index,language:language,limitRow:limitRow,title:title};return axios.get("".concat(API_NEWS_SERVICE,"/news/searchNews?")+queryString.stringify(queryParams));},/**
     * lấy tin phân tích chi tiết mã
     * @param {*} symbol 
     * @param {*} limitRow 
     * @param {*} index 
     * @param {*} language 
     * @returns 
     */getStockSymbolAnalytic:function getStockSymbolAnalytic(symbol,limitRow,index,language){var queryParams={symbols:symbol,limitRow:limitRow,index:index,language:language};return axios.get("".concat(API_NEWS_SERVICE,"/news/getListAnalyticNews?")+queryString.stringify(queryParams));},/**
     * Lấy chi tiết tin tức
     * @param {*} newsId 
     * @returns 
     */getNewsSymbolDetail:function getNewsSymbolDetail(newsId){return axios.get("".concat(API_NEWS_SERVICE,"/news/getNewsDetail/").concat(newsId));},/**
     * Lấy chi tiết phân tích
     * @param {*} analyticId 
     * @returns 
     */getAnalyticSymbolDetail:function getAnalyticSymbolDetail(analyticId){return axios.get("".concat(API_NEWS_SERVICE,"/news/getAnalyticNewsDetail/").concat(analyticId));},/**
     * Lấy thông tin chỉ số chi tiết chỉ số
     * @param {*} floorCode 
     * @returns 
     */getIndexDetail:function getIndexDetail(floorCode){return axios.get("".concat(MARKET_URL,"/datafeed/indexMoreInfo/").concat(floorCode));},/**
     * Lấy lịch sử sự kiện chi tiết mã 
     * @param {*} symbol 
     * @param {*} limitRow 
     * @param {*} index 
     * @param {*} language 
     * @returns 
     */getStockEvent:function getStockEvent(symbol,limitRow,index,language){var queryParams={symbols:symbol,limitRow:limitRow,index:index,language:language};return axios.get("".concat(API_NEWS_SERVICE,"/news/getListStocksEvent?")+queryString.stringify(queryParams));},/**
     * Lấy chi tiết lịch sử sự kiện
     * @param {*} analyticId 
     * @param {*} language 
     * @returns 
     */getEventSymbolDetail:function getEventSymbolDetail(analyticId,language){var queryParams={language:language};return axios.get("".concat(API_NEWS_SERVICE,"/news/getStockEventDetail/").concat(analyticId,"?")+queryString.stringify(queryParams));},/**
     * Lấy thông báo giao dịch, cảnh báo
     * @param {*} custid 
     * @returns 
     */getNotiTransactions:function getNotiTransactions(custid){var queryParams={custid:custid};return axios.get("/notify/account/message?"+queryString.stringify(queryParams));},/**
     * Lấy thông báo khuyến nghị, khác
     * @returns 
     */getNotiAnalytic:function getNotiAnalytic(data){var reportid=data.reportid,limitRow=data.limitRow,index=data.index;var queryParams={limitRow:limitRow,index:index,reportid:reportid};return axios.get("/notify/message/analytic?"+queryString.stringify(queryParams));},/**
     * Lấy thông báo khuyến nghị, khác
     * @returns 
     */getNotiPublicAnalytic:function getNotiPublicAnalytic(data){var reportid=data.reportid,limitRow=data.limitRow,index=data.index;var queryParams={limitRow:limitRow,index:index,reportid:reportid};return axios.get("/notify/message/publicAnalytic?"+queryString.stringify(queryParams));},/**
     * Lấy dữ liệu cho biểu đồ khớp theo giá khớp
     * @param {*} symbol 
     * @returns 
     */getChartMatchedInfoBySymbol:function getChartMatchedInfoBySymbol(symbol){return axios.get("".concat(MARKET_URL,"/datafeed/translog/groupByPrice/").concat(symbol));},/**
     * Lấy thông tin tin tức theo loại thị trường Chuyên mục thị trường
     * @param {*} key 
     * @param {*} groupid 
     * @param {*} limitRow 
     * @param {*} index 
     * @param {*} language 
     * @param {*} fromDate 
     * @param {*} toDate 
     * @returns 
     */getSearchNewsGroupMarket:function getSearchNewsGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/searchNewsGroup?")+queryString.stringify(queryParams));},/**
    * Lấy thông tin tin tức mới Chuyên mục thị trường
    * @param {*} groupid 
    * @param {*} limitRow 
    * @param {*} index 
    * @returns 
    */getNewsGroupMarket:function getNewsGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/getNewsGroup?")+queryString.stringify(queryParams));},/**
    * Lấy thông tin tab ALL tin tức mới Chuyên mục thị trường
    * @param {*} language 
    * @returns 
    */getLatestNewsGroupMarket:function getLatestNewsGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/getLatestNewsGroup?")+queryString.stringify(queryParams));},/**
     * Lấy thông tin phân tích theo loại thị trường Chuyên mục thị trường
     * @param {*} symbols 
     * @param {*} index 
     * @param {*} limitRow 
     * @param {*} language 
     * @param {*} categoryid 
     * @param {*} fromDate 
     * @param {*} toDate 
     * @returns 
     */getSearchAnalyticGroupMarket:function getSearchAnalyticGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/searchAnalyticNewsGroup?")+queryString.stringify(queryParams));},/**
     * Lấy thông tin phân tích mới Chuyên mục thị trường 
     * @param {*} categoryid 
     * @param {*} limitRow 
     * @param {*} index 
     * @param {*} language 
     * @returns 
     */getAnalyticGroupMarket:function getAnalyticGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/getAnalyticNewsGroup?")+queryString.stringify(queryParams));},/**
    * Lấy thông tin tab ALL tin tức mới Chuyên mục thị trường
    * @param {*} language 
    * @returns 
    */getLatestAnalyticGroupMarket:function getLatestAnalyticGroupMarket(body){var queryParams=_objectSpread({},body);return axios.get("".concat(API_NEWS_SERVICE,"/news/getLatestAnalyticNewsGroup?")+queryString.stringify(queryParams));}};export default symbolService;